import React from "react";
import './Contact.css';

export default function () {

    return (

        <section className="Sec-contact pb-5">

            <h2 className="text-center text-white fw-bold pt-4">CONTACT CRYSTAL</h2>

            <p className="text-center text-white pt-4">Mauris mattis vitae libero eget iaculis. Donec et augue quis quam porttitor consectetur ut nec <br />sem. Integer sagittis viverra quam quis ultricies. Aenean risus nisl, consequat at nunc id, tincidunt <br />tristique mauris.</p>

            <div className="container pt-4">
                <div className="row justify-content-between">

                    <input type="text" placeholder="Name" className="p-2 col-12 col-md-3 bg-transparent" />

                    <input type="mail" placeholder="Email" className="p-2 col-12 col-md-3 bg-transparent" />


                    <input type="text" placeholder="Subject" className="p-2 col-12 col-md-3 bg-transparent" />

                    <textarea name="" id="" cols="30" rows="10" className="col-12 col-md-12 mt-4 bg-transparent area-text text-center text-white mt-5" placeholder="Message"></textarea>

                </div>

                <div className="text-center pt-5">

                    <button type="button" className=" last-btn">

                        SHOOT MESSAGE

                    </button>

                </div>

                <p className="text-center text-white pt-5">Copyright © 2015 Your Company Name </p>

               
            </div>

        </section>

    )
}